<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    v-card-text.neutral700--text
      .d-flex.justify-center.my-6
        div(style="width: 70%;")
          //- patient detail
          .text-2xl.font-semibold Patient history
          div.d-flex.align-center.mt-4
            v-avatar.mr-3(size="16" color="neutral300")
              template(v-if="patient.profile_image")
                v-img(:src="`https://img.yezza.io/50x50/${patient.profile_image.path}`")
              v-icon(v-else color="neutral500" size="15") $yzi-user-03
            div.text-sm.font-medium.neutral700--text.mr-3 {{ patient.name }}
            div.text-xs.neutral500--text {{ getDobIc(patient) }}
          //- filters
          div.d-flex.align-center.pt-2
            visit-filter-dropdown(@change="fetchFirstPage")
            diagnoses-filter-dropdown.ml-3(@change="fetchFirstPage")
            doctor-filter-dropdown.ml-3(@change="fetchFirstPage" type="visit")
          //- fetching loader
          template(v-if="isFetching")
            v-skeleton-loader(type="list-item-three-line@3")
          //- no visit found
          template(v-else-if="totalCount === 0")
            div.d-flex.align-center.justify-center.fill-height(style="min-height: 200px;")
              div(align="center")
                v-icon(size="32" color="neutral500") $yzi-clipboard
                div.text-sm.font-medium.neutral700--text.mt-2 No visit found
                div.text-sm.neutral500--text.mt-1 No visit fit your filter criteria
          //- patient history list
          template(v-else)
            div
              template(v-for="history in patientHistories")
                patient-history-item(:patient-history.sync="history" @updated="fetchPatientHistory")

    v-divider
    v-card-actions.px-8.py-3.white
      v-row(no-gutters)
        v-col.grow
        v-col(cols="3")
          yz-pagination(v-model="currentPage" :page-size.sync="pageSize" type="page" :count="totalCount" change-page-size menu-top arrow @input="pageChanged")
        v-col.grow(align="right")
          y-button(label="Close" size="sm" dark @click="closeDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VisitFilterDropdown from '@/components/clinic/consultation/VisitFilterDropdown.vue'
import DiagnosesFilterDropdown from '@/components/clinic/consultation/DiagnosesFilterDropdown.vue'
import DoctorFilterDropdown from '@/components/clinic/consultation/DoctorFilterDropdown.vue'
import PatientHistoryItem from '@/components/clinic/consultation/PatientHistoryItem.vue'

export default {
  components: { VisitFilterDropdown, DiagnosesFilterDropdown, DoctorFilterDropdown, PatientHistoryItem },
  props: {
    open: {
      type: Boolean,
    },
    patient: {
      required: true,
      type: Object,
      default: null
    },
  },
  data () {
    return {
      isFetching: false,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      patientHistories: [],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      visitFilters: 'treatment/getVisitFilters',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    selectedVisits () {
      let ids = null
      if (this.visitFilters.visits) {
        ids = this.visitFilters.visits.map(m => m.lead_id).join(',')
      }
      return ids
    },
    beginDate () {
      let date = null
      if (this.visitFilters.dateRange && this.visitFilters.dateRange.length) {
        date = this.visitFilters.dateRange[0]
      }
      return date
    },
    endDate () {
      let date = null
      if (this.visitFilters.dateRange && this.visitFilters.dateRange.length > 1) {
        date = this.visitFilters.dateRange[1]
      }
      return date
    },
    doctors () {
      let ids = null
      if (this.visitFilters.doctors) {
        ids = this.visitFilters.doctors.map(m => m.value).join(',')
      }
      return ids
    },
    diagnoses () {
      let ids = null
      if (this.visitFilters.diagnoses) {
        ids = this.visitFilters.diagnoses.map(m => m.label).join(',')
      }
      return ids
    },
  },
  watch: {
    pageSize () {
      this.fetchFirstPage()
    },
  },
  mounted () {
    this.fetchPatientHistory()
  },
  beforeDestroy () {
    this.$store.commit('treatment/resetVisitFilters')
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPatientHistory () {
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage,
        ids: this.selectedVisits,
        begin: this.beginDate,
        until: this.endDate,
        providers: this.doctors,
        diagnoses: this.diagnoses,
      }
      this.$axios.get(`/clinics/${this.company.slug}/patients/${this.patient.id}/histories`, { params })
        .then(resp => {
          this.patientHistories = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchPatientHistory()
    },
    pageChanged () {
      this.fetchPatientHistory()
    },
    getDobIc (patient) {
      let items = []
      if (patient.dob) {
        let age = `${this.$options.filters.displayAgeByYearMonthDay(this.$options.filters.getAgeByYearMonthDay(patient.dob))} old`
        items.push(age)
      } if (patient.ic) {
        items.push(patient.ic)
      }
      return items.join(' | ')
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.content-box {
  border: 1px var(--v-neutral300) solid !important;
}
</style>